export enum EwicReceiptType {
  BALANCEINQUIRY = 'BALANCEINQUIRY',
  INITIALBALANCE = 'INITIALBALANCE',
}
